const swiper = new Swiper('.sample-slider', {
    loop: true,
    slidesPerView: 1.15,
    spaceBetween: 0,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    grabCursor: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    speed: 1080,
    easing: 'easeInOutCubic',
    breakpoints: {
        768: {
            slidesPerView: 4.5,
            spaceBetween: 0,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            centeredSlides: true,
        },
    },
});